import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar.js';
import PageTitle from '../../components/pagetitle/PageTitle.js';
import NewsList from '../../components/NewsList/NewsList.js';
import Scrollbar from '../../components/scrollbar/scrollbar.js';
import Footer from '../../components/footer/Footer.js';

const BlogPageFullwidth = () => {
	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={'Actualités'} pagesub={'Actualités'} />
			<NewsList />
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default BlogPageFullwidth;
